/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostMemoryCommentImagesSignedurlRequestFileInfosInner } from './PostMemoryCommentImagesSignedurlRequestFileInfosInner';
import {
    PostMemoryCommentImagesSignedurlRequestFileInfosInnerFromJSON,
    PostMemoryCommentImagesSignedurlRequestFileInfosInnerFromJSONTyped,
    PostMemoryCommentImagesSignedurlRequestFileInfosInnerToJSON,
} from './PostMemoryCommentImagesSignedurlRequestFileInfosInner';

/**
 * 
 * @export
 * @interface PostMemoryCommentImagesSignedurlRequest
 */
export interface PostMemoryCommentImagesSignedurlRequest {
    /**
     * 
     * @type {Array<PostMemoryCommentImagesSignedurlRequestFileInfosInner>}
     * @memberof PostMemoryCommentImagesSignedurlRequest
     */
    fileInfos: Array<PostMemoryCommentImagesSignedurlRequestFileInfosInner>;
}

/**
 * Check if a given object implements the PostMemoryCommentImagesSignedurlRequest interface.
 */
export function instanceOfPostMemoryCommentImagesSignedurlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileInfos" in value;

    return isInstance;
}

export function PostMemoryCommentImagesSignedurlRequestFromJSON(json: any): PostMemoryCommentImagesSignedurlRequest {
    return PostMemoryCommentImagesSignedurlRequestFromJSONTyped(json, false);
}

export function PostMemoryCommentImagesSignedurlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostMemoryCommentImagesSignedurlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileInfos': ((json['fileInfos'] as Array<any>).map(PostMemoryCommentImagesSignedurlRequestFileInfosInnerFromJSON)),
    };
}

export function PostMemoryCommentImagesSignedurlRequestToJSON(value?: PostMemoryCommentImagesSignedurlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileInfos': ((value.fileInfos as Array<any>).map(PostMemoryCommentImagesSignedurlRequestFileInfosInnerToJSON)),
    };
}

